export const BRAND = {
	LEXUS: 'lexus',
	TOYOTA: 'toyota',
}

export const GTM_ID = {
	lexus: {
		PROD: 'GTM-TBMZX75',
		ACC: 'GTM-5D6FTVX'
	},
	toyota: {
		PROD: 'GTM-M888SFJ',
		ACC: 'GTM-KCZWG74'
	}
}